// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"b88caf4f","159":"38afa11d","393":"f6d9cc07","931":"be5497de"}[chunkId] + ".chunk.css";
};